export default function getForwardContentPlainText(html: string): string {
    try {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        // Look for the divRplyFwdMsg id and remove it since this can cause missleading detections due to outlook UI being on a different language.
        const forwardBlock = doc.querySelector('[id$="divRplyFwdMsg"]');
        forwardBlock.remove();

        const styleElements = doc.querySelectorAll('style');
        if (styleElements && styleElements.length > 0) {
            for (let i = 0; i < styleElements.length; i++) {
                if (styleElements[i]) {
                    // Style elements don't have innerHTML, just innerText
                    styleElements[i].innerText = '';
                }
            }
        }

        let body = doc.body.textContent || '';

        return body;
    } catch (e) {
        return '';
    }
}
